import { render } from "./LRLQ.vue?vue&type=template&id=c2517354&scoped=true"
import script from "./LRLQ.vue?vue&type=script&lang=js"
export * from "./LRLQ.vue?vue&type=script&lang=js"

import "./LRLQ.vue?vue&type=style&index=0&id=c2517354&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2517354"]])

export default __exports__